__turbopack_context__.v({
  "buttonSpacer": "styles-module-scss-module__cwmvTa__buttonSpacer",
  "buttonWrapper": "styles-module-scss-module__cwmvTa__buttonWrapper",
  "container": "styles-module-scss-module__cwmvTa__container",
  "contentGrid": "styles-module-scss-module__cwmvTa__contentGrid",
  "description": "styles-module-scss-module__cwmvTa__description",
  "gray": "styles-module-scss-module__cwmvTa__gray",
  "mediaFirst": "styles-module-scss-module__cwmvTa__mediaFirst",
  "mint": "styles-module-scss-module__cwmvTa__mint",
  "textWrapper": "styles-module-scss-module__cwmvTa__textWrapper",
});
